<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          readonly
          label="Turto rūšis"
          tooltip="Hipoteka. Turtas. NTR. Turto rūšis"
          v-model="formData.tur_ntr_rusis"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          readonly
          label="Registro numeris"
          tooltip="Hipoteka. Turtas. NTR. Registro numeris"
          v-model="formData.reg_nr"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          readonly
          label="Unikalus numeris"
          tooltip="Hipoteka. Turtas. NTR. Unikalus numeris"
          v-model="formData.tur_identifikatorius"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          readonly
          label="Turto adresas"
          tooltip="Hipoteka. Turtas. NTR. Turto adresas"
          v-model="formData.tur_ntr_adresas"
        />
      </v-col>
      <template v-if="isTeise">
        <v-col cols="12" md="6">
          <el-text-field
            readonly
            label="Įregistravimo pagrindas"
            tooltip="Hipoteka. Turtas. NTR. Įregistravimo pagrindas"
            v-model="teisesPagrindas"
          />
        </v-col>
        <v-col cols="12" md="6">
          <el-text-field
            readonly
            label="Turtinės teisės terminas"
            tooltip="Hipoteka. Turtas. NTR. Turtinės teisės terminas"
            v-model="teisesTerminas"
          />
        </v-col>
      </template>
      <v-col cols="12" md="12">
        <el-textarea
          readonly
          label="Aprašymas iš NTR"
          tooltip="Hipoteka. Turtas. NTR. Aprašymas"
          v-model="formData.tur_ntr_aprasymas"
        />
      </v-col>
      <v-col cols="12" md="6" v-if="showDalis">
        <el-checkbox
          label="Dalis"
          tooltip="Hipoteka. Turtas. NTR. Dalis"
          :readonly="readonly"
          v-model="formData.tur_ntr_dalis"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasNtr',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
    isTeise() {
      return this.formData.tur_ntr_teit_tipas != 1
    },
    teisesPagrindas() {
      return `${this.formData.doku_pav} ${
        this.formData.dok_nr ? ' Nr. ' + this.formData.dok_nr : ''
      }`
    },
    teisesTerminas() {
      if (!this.formData.tei_terminas_nuo && !this.formData.tei_terminas_iki) {
        return null
      }

      return `${
        this.formData.tei_terminas_nuo
          ? 'nuo ' + this.formData.tei_terminas_nuo + ' '
          : ''
      }${
        this.formData.tei_terminas_iki
          ? 'iki ' + this.formData.tei_terminas_iki
          : ''
      }`
    },
    showDalis() {
      return !this.isTeise
    },
  },
}
</script>
